<!--MAINTENANCE DOWNTIME-->
<ng-container *ngIf="maintenance">
  <section class="maintenance-outer">
    <div class="wrapper">
      <!--CMS HTML CONTENT-->
      <div class="maintenance">
        <!--BEYOND LOGO-->
        <div class="padding-left-large padding-top-large beyond-logo">
          <span>Genesys | Education</span>
        </div>
        <!--END BEYOND-->
        <div
          class="maintenance-content padding-top-large padding-right-large padding-bottom-large padding-left-large"
          [innerHTML]="maintenance?.content"></div>
      </div>
      <!--END CMS HTML CONTENT-->
    </div>
  </section>
</ng-container>
<!--END MAINTENANCE DOWNTIME-->
